import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef } from "react";
import Header from '../components/Header';
import { BsCalendar4Week, BsSearch, BsFillPinMapFill } from "react-icons/bs";
import Sheet from 'react-modal-sheet';
import { ko } from "date-fns/locale";
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import NoData from "../components/NoData";
import Product5 from "../components/Product5";
import { useAxios } from "../services/useAxios";
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import DelivManagement from "./DelivManagement"
import {alert, confirm} from "../components/MegConfirmAlert";
import { useDaumPostcodePopup } from 'react-daum-postcode';

export default function OrderHistory (){
    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(false);
    const { control }= useForm();
    const [data, setData] = useState({});
    const [isMapOpen, setMapOpen] = useState(false);
    const [request] = useAxios();
    const [isDelivOpen, setDelivOpen] = useState(false);
    const [isDepositOpen, setDepositOpen] = useState(false);
    const [deposit, setDeposit] = useState({});    
    const open = useDaumPostcodePopup();
    let now = new Date();
    const [srchStartDt, setSrchStartDt] = useState(new Date(now.setMonth(now.getMonth()-1)));
    const [srchEndDt, setSrchEndDt] = useState(new Date());
    const [month, setMonth] = useState('0');
    const {register, handleSubmit, setValue,  reset, formState, clearErrors }= useForm();
    const{errors} = formState;  
    const phoneRegex = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
    const lang = localStorage.getItem("language") || "ko";


    function regPhoneNumber(e) {
        const result = e.target.value
          .replace(/[^0-9.]/g, "")
          .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
          .replace(/(-{1,2})$/g, "");

        setValue('recptrCttpc', result, { shouldValidate: true })          
    }

    const fn_processSttusBtn = (obj, order) => {
        const code = obj.orderProcessSttusCode        
        if(code === 'ODR001' || code === 'ODR002' || code === 'ODR003' ){            
            return(
                <>
                    <Link onClick={(e)=> {fn_checkDlvyInfo(obj,order)}}> {t(`Message.my_order_hist_list_dlvy_chg`)}</Link>
                    {code === 'ODR002' && order.payMethod === 'va'?(
                    <Link onClick={(e)=> {fn_depositInfo(order.orderNo)}}>{t(`Message.my_order_hist_list_deposit_info`)}</Link>
                    ):(
                    <Link to={"/OrderCancel/"+order.orderNo}>{t(`Message.my_order_hist_list_order_cancel`)}</Link>
                    )}
                </>
             );
        }else  if(code === 'ODR004'){
            return(
                <>
                    <Link to={"/DelivStatus/"+order.orderNo}>{t(`Message.my_order_hist_list_dlvy_sch`)}</Link>
                </>
             );
        }else  if(code === 'ODR005'){
            return(
                <>
                    <Link to={"/ConfirmGoodsReceived/"+order.orderNo}>{t(`Message.my_order_hist_list_purchase_confirm`)}</Link>
                    <Link to={"/ReturnRequest/"+order.orderNo}>{t(`Message.my_order_hist_list_return_req`)}</Link>
                </>
             );
        }else  if(code === 'ODR006' && obj.reviewAt === 'N'){
            return(
                <>
                    <Link to={"/ReviewWrite/"+obj.orderDetailSn}>{t(`Message.my_order_hist_list_review_reg`)}</Link>
                </>
             );
        }
           
    }

    const fn_checkDlvyInfo = async(obj, order) => {   
        reset({})   
        console.log("data",obj)
        const response = await request.post("/app/order/getOrderSheetInfoAPI", {
            orderNo: order.orderNo
        });
        
        if(response.data.resultCode === 200){     
            if(response.data.result.orderSheetVO.extraDlvyCtAmount ===0){                
                reset(response.data.result.orderSheetVO);
                setDelivOpen(true)
            }else{
                alert("도서산간지역 배송지는 배송지변경이 불가능합니다.")

            }       
            
        }
        
    }


    const handleComplete = (data) => {
        let addr = '';
        let extraAddr = '';
        
        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
        } else { // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
        }

        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
        if(data.userSelectedType === 'R'){
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if(data.buildingName !== '' && data.apartment === 'Y'){
                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if(extraAddr !== ''){
                extraAddr = ' (' + extraAddr + ')';
            }
            // 조합된 참고항목을 해당 필드에 넣는다.
            setValue("recptrDetailAdres", extraAddr);
        
        } else {
            setValue("recptrDetailAdres", '');            
        }

        // 우편번호와 주소 정보를 해당 필드에 넣는다.
        setValue("recptrZip", data.zonecode);
        setValue("recptrBassAdres",addr);
        clearErrors('recptrZip')
        clearErrors('recptrBassAdres')
      };

    const fn_depositInfo = async(orderNo) => {     
       
        const response = await request.post("/app/order/getOrderSheetInfoAPI", {
            orderNo: orderNo
        });
        if(response.data.resultCode === 200){     
           setDeposit(response.data.result)
           console.log(response.data.result)  
           setDepositOpen(true)
        }
        
    }

    const fn_checkMonth = (e) => {
        setMonth(e.target.value);
        if(e.target.value === '0'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-1)));
            setSrchEndDt(new Date());
        }else if(e.target.value === '1'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-3)));
            setSrchEndDt(new Date());
        }else if(e.target.value === '2'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-6)));
            setSrchEndDt(new Date());
        }else if(e.target.value === '3'){
            let now = new Date();
            setSrchStartDt(new Date(now.setMonth(now.getMonth()-12)));
            setSrchEndDt(new Date());
        }
        
    }

    

    const onSubmit = async data=> {
        const result = await confirm('배송지 정보를 수정하시겠습니까?', {okText : t(`Message.common_yes`) , cancelText : t(`Message.common_no`)});
        if(!result){
            return
        }
        const response = await request.post("/app/mypage/modOrderDlvyAdresAPI", data);        
        if(response.data.resultCode === 200){     
            alert(response.data.resultMessage);
            setDelivOpen(false)
        }else{
            alert("도서산간지역 배송지는 배송지변경이 불가능합니다.")
        }

    }
 
    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMyOrderDlvyAPI", {
            srchStartDt: moment(srchStartDt).format('YYYY-MM-DD'),
            srchEndDt : moment(srchEndDt).format('YYYY-MM-DD'),
            nationSeCode:lang
        });

        if(response.data.resultCode === 200){
            setData(response.data.result);          
            console.log(response.data.result);
        }
    };

    useEffect(() => {
        fetchData();
      }, []);
    return (
    <div>
        {data.myTotalOrderCnt?(     
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.my_order_hist_list_title`)}/>

            <div className="pl20 pr20">
                <div className="orderStatus">
                    <button type="button" className="osBtn">
                        <span className="tit">{t(`Message.my_order_hist_list_dlvy_ing`)}</span>
                        <span className="num">{data.myTotalOrderCnt.odr004}</span>
                    </button>
                    <button type="button" className="osBtn">
                        <span className="tit">{t(`Message.my_order_hist_list_dlvy_complete`)}</span>
                        <span className="num">{data.myTotalOrderCnt.odr005}</span>
                    </button>
                    <button type="button" className="osBtn">
                        <span className="tit">{t(`Message.my_order_hist_list_cancel_return`)}</span>
                        <span className="num">{data.myTotalOrderCnt.cancelReturnCnt}</span>
                    </button>
                    <button type="button" className="osBtn">
                        <span className="tit">{t(`Message.my_order_hist_list_purchase_confirm`)}</span>
                        <span className="num">{data.myTotalOrderCnt.odr006}</span>
                    </button>
                </div>
                <p className="fs12 cFFF txtR mt6">{t(`Message.my_order_hist_list_default_msg`)}</p>


                <div className="historyDate dfsb mt24">
                    <div className="dfcsG4">
                        <BsCalendar4Week className="mr4"/>
                        <p>{moment(srchStartDt).format('YYYY-MM-DD')}</p>
                        <span>~</span>
                        <p>{moment(srchEndDt).format('YYYY-MM-DD')}</p>
                    </div>
                    <div className="buttonArea">
                        <button type="button" 
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                setOpen(true);
                            }}
                            className="btn24 orgB cFFF">
                                {t(`Message.my_order_hist_list_set_period`)}
                        </button>
                    </div>
                </div>

                {!data.orderSheetList || data.orderSheetList.length === 0? (
                <div className="floatCenter mt40">
                    <NoData text={t(`Message.my_order_hist_list_empty`)}/>
                </div>                
                ):null}




                <div className="orderHistoryWr">
                    {data.orderSheetList && data.orderSheetList.map((order, index) => (     
          
                    <div className="orderHistory" key={index}>
                        <ul className="dfsbG12 pt8 pb8">
                            <li>
                                <p className="orderNum">{t(`Message.my_order_hist_list_order_no`)} {order.orderNo}</p>
                                <p className="date">{order.orderDt}</p>
                            </li>
                            <li>
                                <Link to={"/OrderHistoryDetail/"+order.orderNo} className="greenB cFFF btn24">{t(`Message.my_order_hist_list_order_dtl`)}</Link>
                            </li>
                        </ul>
                        <div className="dfColG6">
                            {order.ohlist && order.ohlist.map((obj, index2) => (    
                            <div className="ohProd" key={index2}>
                                                                
                                <Product5 type="type14" 
                                    img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+(obj.goodsImageSn?obj.goodsImageSn:0)}
                                    status={obj.orderProcessSttusCodeNm}
                                    prodName={obj.goodsNm}
                                    option={obj.firstOptnNm + ' ' +obj.firstOptnValue}       
                                    disprice={"￦"+obj.orderAmount.toLocaleString('ko-KR')}
                                />
                                
                                <div className="btnWr">
                                    {fn_processSttusBtn(obj,order)}
                                </div>

                            </div>
                            ))}                              
                        </div>
                    </div>
                   ))}   

                </div>


            </div>



            <Sheet isOpen={isOpen} onClose={() => setOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 setDateModal">
                        <h3 className="btModalTit">{t(`Message.my_order_hist_list_set_period`)}</h3>
                        <ul className="dfcsG6 inputWr">
                            <li>
                                <Controller
                                    name={"srchStartDt"}                  
                                    control={control}                  
                                    rules={{  required:"필수 응답 항목입니다."  }}
                                    defaultValue={srchStartDt}
                                    render={({ field: { onChange } }) => {
                                        return (
                                        <DatePicker
                                            locale={ko}
                                            onChange={(date) =>{onChange(date); setSrchStartDt(date)}}
                                            selected={srchStartDt}
                                            dateFormat="yyyy-MM-dd"
                                            maxDate={srchEndDt}
                                            
                                        />
                                        );
                                    }}
                                />
                                <BsCalendar4Week/>
                            </li>
                            <li className="bd0">~</li>
                            <li>
                                <Controller
                                    name={"srchEndDt"}                  
                                    control={control}                  
                                    rules={{  required:"필수 응답 항목입니다."  }}
                                    defaultValue={srchEndDt}
                                    render={({ field: { onChange } }) => {
                                        return (
                                        <DatePicker
                                            locale={ko}
                                            onChange={(date) =>{onChange(date); setSrchEndDt(date)}}
                                            selected={srchEndDt}
                                            dateFormat="yyyy-MM-dd"
                                            minDate={srchStartDt}
                                        />
                                        );
                                    }}
                                />
                                <BsCalendar4Week/>
                            </li>
                        </ul>
                        <div className="radioWr dfcsG12">
                            <input type="radio" name="month" id="mon1" onChange={(e)=> fn_checkMonth(e)}  value="0" checked={month === '0'} />
                            <label htmlFor="mon1">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 1})}</label>
                            <input type="radio" name="month" id="mon3" onChange={(e)=> fn_checkMonth(e)}  value="1" checked={month === '1'}/>
                            <label htmlFor="mon3">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 3})}</label>
                            <input type="radio" name="month" id="mon6" onChange={(e)=> fn_checkMonth(e)}  value="2" checked={month === '2'}/>
                            <label htmlFor="mon6">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 6})}</label>
                            <input type="radio" name="month" id="mon12" onChange={(e)=> fn_checkMonth(e)}  value="3" checked={month === '3'}/>
                            <label htmlFor="mon12">{t(`Message.my_order_detail_payment_info_pay_card_quota2` , {cardQuota : 12})}</label>
                        </div>
                    </div>
                    <div className="btnWr mt10">
                        <button type="button" className="btn40 wgB cDisa" onClick={() => setOpen(false)}>{t(`Message.common_cancel`)}</button>
                        <button type="button" className="btn40 orgB cFFF" onClick={() => {setOpen(false); fetchData()}}>변경</button>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setOpen(false)}/>
            </Sheet>
        </div>
         ):null}

        <Modal
            className="btModal"
            show={isDelivOpen}
            onHide={setDelivOpen}
            fullscreen={true}
            aria-labelledby="contained-modal-title-vcenter"
            centered                
            keyboard={false}
            >
            <div className="modalPage">
                <Header type={'modal'} pageTitle={t(`Message.dlvy_info_modify_title`)} closeFn={setDelivOpen}/>
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <ul className="adrForm">
                            <li>
                                <p>{t(`Message.dlvy_info_regist_recpt`)}</p>
                                <input type="text" maxLength={50} placeholder={t(`Message.dlvy_info_regist_hint_recpt`)} {...register("recptrNm", { required: t(`Message.dlvy_info_regist_required_recpt`)})} />
                                {errors.recptrNm && <p role="alert" className="alertRed">{errors.recptrNm.message}</p>}
                            </li>
                            <li>
                                <p>{t(`Message.dlvy_info_regist_contact`)}</p>
                                <input type="tel" maxLength={13} placeholder={t(`Message.dlvy_info_regist_invalid_contact`)}  {...register("recptrCttpc", { onChange: (e) => {regPhoneNumber(e)}, required: t(`Message.ordrr_form_required_mobile`), pattern: {value: phoneRegex, message: "올바른 휴대폰 형식이 아닙니다." }})}/>
                                {errors.recptrCttpc && <p role="alert" className="alertRed">{errors.recptrCttpc.message}</p>}
                            </li>
                            <li>
                                <div className="dfcsG12 w100per">
                                    <button type="button" className="greenB cFFF btn36" onClick={(e)=>open({ onComplete: handleComplete })}><BsSearch /> {t(`Message.dlvy_info_regist_adres_search`)}</button>
                                    <button type="button" className="line btn36" onClick={(e)=>setMapOpen(true)}><BsFillPinMapFill /> {t(`Message.dlvy_info_regist_find_current_loc`)}</button>
                                </div>
                                    
                                <div className="dfColG4 pt16">
                                    <p className="tit mb8">{t(`Message.dlvy_info_regist_adres`)}</p>
                                    <input type="text" {...register("recptrZip", { required:t(`Message.dlvy_info_regist_required_adres`)})}  disabled/>
                                    {errors.recptrZip && <p role="alert" className="alertRed">{errors.recptrZip.message}</p>}
                                    <input type="text" {...register("recptrBassAdres", { required:t(`Message.dlvy_info_regist_required_adres`)})}  disabled/>
                                    {errors.recptrBassAdres && <p role="alert" className="alertRed">{errors.recptrBassAdres.message}</p>}
                                    <input type="text" placeholder={t(`Message.dlvy_info_regist_hint_dtl_adres`)} {...register("recptrDetailAdres", { })} />
                                    {errors.recptrDetailAdres && <p role="alert" className="alertRed">{errors.recptrDetailAdres.message}</p>}
                                </div>
                                    
                            
                            </li>
                            <li>
                                <p className="tit">{t(`Message.dlvy_info_regist_entrnc_pass`)}</p>
                                <input type="text" {...register("entrncPass", { })} placeholder={t(`Message.dlvy_info_regist_hint_entrnc_pass`)} />
                            </li>
                        </ul>
                        <button type="submit" className="floatBtn">{t(`Message.saveBtn`)}</button>  
                    </form>
                </div>  
            </div>          
        </Modal>

        <Sheet isOpen={isDepositOpen} onClose={() => setDepositOpen(false)} className="bottomModal">
            <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
                <div className="setDateModal dfColG20">
                    <h3 className="tit">{t(`Message.my_order_deposit_bottom_sheet_title`)}</h3>
                    <ul className="modalSellerInfo">
                        <li>
                            <p className="tit">{t(`Message.my_order_deposit_bottom_sheet_deposit_account`)}</p>
                            <p className="cont">{deposit.vaInfo?.bank_nm} {deposit.vaInfo?.va_no}</p>
                        </li>
                        <li>
                            <p className="tit">{t(`Message.my_order_deposit_bottom_sheet_amt`)}</p>
                            <p className="cont">{deposit.orderSheetVO?.lastSetleAmount}</p>
                        </li>
                        <li>
                            <p className="tit">{t(`Message.my_order_deposit_bottom_sheet_exp_dt`)}</p>
                            <p className="cont">{deposit.vaInfo?.expr_tlml}</p>
                        </li>                       
                    </ul>
                </div>
                <div className="btnWr">
                    <button type="button" onClick={() => setDepositOpen(false)} className="btn40 wgB cDisa">{t(`Message.common_close`)}</button>
                </div>
            </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onClick={() => setDepositOpen(false)}/>
        </Sheet>

         </div>
    );
};